import { render, staticRenderFns } from "./remarks.vue?vue&type=template&id=1c144d38&scoped=true"
import script from "./remarks.vue?vue&type=script&lang=js"
export * from "./remarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c144d38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c144d38')) {
      api.createRecord('1c144d38', component.options)
    } else {
      api.reload('1c144d38', component.options)
    }
    module.hot.accept("./remarks.vue?vue&type=template&id=1c144d38&scoped=true", function () {
      api.rerender('1c144d38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bulkyExpress/largeOrderManagement/component/remarks.vue"
export default component.exports